export const languageList =
    [
        { text: "English", value: "English" },
        { text: "Afrikaans", value: "Afrikaans" },
        { text: "Albanian", value: "Albanian" },
        { text: "Arabic", value: "Arabic" },
        { text: "Armenian", value: "Armenian" },
        { text: "Azerbaijani", value: "Azerbaijani" },
        { text: "Basque", value: "Basque" },
        { text: "Belarusian", value: "Belarusian" },
        { text: "Bengali", value: "Bengali" },
        { text: "Bosnian", value: "Bosnian" },
        { text: "Bulgarian", value: "Bulgarian" },
        { text: "Catalan", value: "Catalan" },
        { text: "Chinese Simplified", value: "Chinese Simplified" },
        { text: "Chinese Traditional", value: "Chinese Traditional" },
        { text: "Croatian", value: "Croatian" },
        { text: "Czech", value: "Czech" },
        { text: "Danish", value: "Danish" },
        { text: "Dutch", value: "Dutch" },
        { text: "Estonian", value: "Estonian" },
        { text: "Filipino", value: "Filipino" },
        { text: "Finnish", value: "Finnish" },
        { text: "French", value: "French" },
        { text: "Galician", value: "Galician" },
        { text: "Georgian", value: "Georgian" },
        { text: "German", value: "German" },
        { text: "Greek", value: "Greek" },
        { text: "Gujarati", value: "Gujarati" },
        { text: "Haitian Creole", value: "Haitian Creole" },
        { text: "Hebrew", value: "Hebrew" },
        { text: "Hindi", value: "Hindi" },
        { text: "Hungarian", value: "Hungarian" },
        { text: "Icelandic", value: "Icelandic" },
        { text: "Indonesian", value: "Indonesian" },
        { text: "Irish", value: "Irish" },
        { text: "Italian", value: "Italian" },
        { text: "Japanese", value: "Japanese" },
        { text: "Khmer", value: "Khmer" },
        { text: "Korean", value: "Korean" },
        { text: "Lao", value: "Lao" },
        { text: "Latvian", value: "Latvian" },
        { text: "Lithuanian", value: "Lithuanian" },
        { text: "Macedonian", value: "Macedonian" },
        { text: "Malay", value: "Malay" },
        { text: "Malayalam", value: "Malayalam" },
        { text: "Maltese", value: "Maltese" },
        { text: "Nepali", value: "Nepali" },
        { text: "Norwegian", value: "Norwegian" },
        { text: "Other", value: "Other" },
        { text: "Pashto", value: "Pashto" },
        { text: "Persian", value: "Persian" },
        { text: "Polish", value: "Polish" },
        { text: "Portuguese", value: "Portuguese" },
        { text: "Punjabi", value: "Punjabi" },
        { text: "Romanian", value: "Romanian" },
        { text: "Russian", value: "Russian" },
        { text: "Serbian", value: "Serbian" },
        { text: "Slovak", value: "Slovak" },
        { text: "Slovenian", value: "Slovenian" },
        { text: "Spanish", value: "Spanish" },
        { text: "Swahili", value: "Swahili" },
        { text: "Swedish", value: "Swedish" },
        { text: "Tamil", value: "Tamil" },
        { text: "Telugu", value: "Telugu" },
        { text: "Thai", value: "Thai" },
        { text: "Turkish", value: "Turkish" },
        { text: "Ukrainian", value: "Ukrainian" },
        { text: "Urdu", value: "Urdu" },
        { text: "Vietnamese", value: "Vietnamese" },
        { text: "Welsh", value: "Welsh" },
        { text: "Yiddish", value: "Yiddish" }
    ]
